import React from 'react';
import { cn } from '@/lib/utils';
import { BaseCalendarProps, CalendarEvent } from './types';
import { EventChip } from './EventChip';

export interface WeekViewProps extends BaseCalendarProps {
  weekStart?: Date; // start of the week
  firstDayOfWeek?: 0 | 1;
}

function startOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function addDays(date: Date, days: number) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function eventsForDay(events: CalendarEvent[] | undefined, day: Date) {
  if (!events) return [] as CalendarEvent[];
  const start = startOfDay(day);
  const end = addDays(start, 1);
  return events.filter((e) => e.start < end && e.end > start);
}

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const WeekView: React.FC<WeekViewProps> = ({ weekStart = startOfDay(new Date()), firstDayOfWeek = 1, events, onEventClick }) => {
  // Adjust weekStart to the chosen firstDayOfWeek
  const diff = (weekStart.getDay() + 7 - firstDayOfWeek) % 7;
  const first = addDays(weekStart, -diff);
  const days = Array.from({ length: 7 }, (_, i) => addDays(first, i));

  return (
    <div className="w-full">
      <div className="grid grid-cols-7 gap-2">
        {days.map((day, idx) => (
          <div key={idx} className="bg-white border rounded-lg p-2">
            <div className="text-sm font-medium mb-2 flex items-center justify-between">
              <span>{WEEKDAY_LABELS[(idx + firstDayOfWeek) % 7]} {day.getDate()}</span>
            </div>
            <div className="space-y-1">
              {eventsForDay(events, day)
                .sort((a, b) => a.start.getTime() - b.start.getTime())
                .map((ev) => (
                  <EventChip key={ev.id} event={ev} onClick={onEventClick} />
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


